(function ($) {
	$(function () {
		$("section.relation input[type=checkbox]").change(function () {
			let $target	=	$(this);
			
			if($target.is(":checked")) {
				$target.next("dl").children("dd").stop().slideDown();
			}
			else {
				$target.next("dl").children("dd").stop().slideUp();
			}
		});

		let $other	=	$("section.point .other")

		$(".modals .modal").each(function () {
			$(this).append($other.clone());
		});

		$("input[name=mode]").on("change", function () {
			let $target	=	$(this);

			$(".reforms .reform").css({position: "absolute"}).stop().fadeOut();

			$(".reforms .reform."+ $target.val()).css({position: "relative"}).stop().fadeIn();
		}).filter(":checked").trigger("change");

		$("[data-modal]").on("click", function () {
			$(".modal").hide();
			$(".modal#"+ $(this).attr("data-modal")).show();

			let adjust	=	$("body").innerWidth();

			$("body").css({overflow: "hidden"});

			$("body").css({paddingRight: $("body").innerWidth() - adjust +"px"});
			
			$(".modals").fadeIn().css({display: "flex"});
		});

		$(".modal .close").on("click", function () {
			$(".modals").fadeOut(function () {
				$("body").css({
					paddingRight	:	"",
					overflow		:	""
				});
			});
		});
		
		$(".modals .modal .photos").addClass("swiper");
		$(".modals .modal .photos > ul").addClass("swiper-wrapper");
		$(".modals .modal .photos > ul > li").addClass("swiper-slide");
		$(".modals .modal .thumbnails").addClass("swiper");
		$(".modals .modal .thumbnails > ul").addClass("swiper-wrapper");
		$(".modals .modal .thumbnails > ul > li").addClass("swiper-slide");
		
		$(".modals .modal").each(function () {
			let $target	=	$(this);

			if($target.find(".thumbnails").length == 0) {
				return true;
			}
			
			const thumbnails	=	new Swiper($target.find(".thumbnails").get(0), {
				slidesPerView	:	5,
				spaceBetween	:	5,
				breakpoints		:	{
					969	:	{
						slidesPerView	:	7,
					}
				}
			});
			
			const swiper	=	new Swiper($target.find(".photos").get(0), {
				loop	:	true,
				effect	:	"fade",
				thumbs	:	{
					swiper	:	thumbnails,
				},
			});
		});
	});
})(jQuery);